import script from "./HomeHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeHeader.vue?vue&type=script&setup=true&lang=js"

import "./HomeHeader.vue?vue&type=style&index=0&id=22a36419&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22a36419"]])

export default __exports__